// A cold load of '/' opens the application home (routes.js). The chrome's portal button reloads the whole
// shell at '/' instead (legacy c_reloadWebApp() → RELOAD_WEBAPP, iframeWatcher.js): this one-shot
// sessionStorage flag, set right before that reload, tells the two apart. Node-safe: no storage, no portal.
const PORTAL_REQUEST_KEY = 'vuePortalRequested';

const session = () => {
	try {
		return globalThis.sessionStorage ?? null;
	} catch {
		return null;
	}
};

export function requestPortal() {
	try {
		session()?.setItem(PORTAL_REQUEST_KEY, '1');
	} catch {
		// storage blocked: the reload lands on the application home
	}
}

export function consumePortalRequest() {
	try {
		const storage = session();
		if (storage?.getItem(PORTAL_REQUEST_KEY) !== '1') return false;
		storage.removeItem(PORTAL_REQUEST_KEY);
		return true;
	} catch {
		return false;
	}
}
